import { makeStyles } from '@material-ui/core';
import {
    addBusinessDays,
    addDays,
    differenceInBusinessDays,
    differenceInDays,
    isWeekend,
    max,
    nextMonday,
    startOfToday,
} from 'date-fns';
import React from 'react';
import { usePrefixTranslation } from '../../../i18n';
import { actions, useTypedDispatch, useTypedSelector } from '../../../redux';
import { DatePicker, Select, TextField } from '../../global';

const useScheduleClasses = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
    inputs: {
        display: 'flex',
        flexWrap: 'wrap',
        margin: '10px -5px',
        '& > div': {
            flex: '1 0 calc(100% / 5 - 20px)',
            minWidth: 100,
            margin: '0 5px',
        },
        '& > .MuiTextField-root': {
            marginBottom: 0,
        },
    },
});

/**
 * Edit the scheduling options for the project scheduler.
 */
export const Schedule = () => {
    const classes = useScheduleClasses();
    const { t } = usePrefixTranslation('project', { project: 'scheduler.Schedule' });
    const dispatch = useTypedDispatch();
    const { asset, project, plan } = useTypedSelector(state => ({
        asset: state.asset.changed,
        project: state.project.changed,
        plan: state.plan.changed,
    }));

    if (!asset || !plan || !project) return <span>{'#asset or plan or project not in store'}</span>;

    const diff = project?.weekend ? differenceInDays : differenceInBusinessDays;
    const add = project?.weekend ? addDays : addBusinessDays;
    const difference = diff(project.estimated_completed_date, project.estimated_start_date);

    return (
        <div className={classes.root}>
            <div className={classes.inputs}>
                <DatePicker
                    label={t('input-date')}
                    value={project.estimated_start_date}
                    onChange={date => {
                        if (!date) return;
                        const start = max([startOfToday(), date]);
                        const estimated_start_date = !project.weekend && isWeekend(start) ? nextMonday(start) : start;
                        const estimated_completed_date = add(estimated_start_date, difference);
                        dispatch(actions.project.edit({ estimated_start_date, estimated_completed_date }));
                    }}
                />
                <TextField
                    key={difference}
                    label={t('input-duration')}
                    type='number'
                    defaultValue={Math.max(1, difference + 1)}
                    onBlur={event => {
                        const difference = Math.max(+event.target.value - 1, 0);
                        const estimated_completed_date = add(project.estimated_start_date, difference);
                        dispatch(actions.project.edit({ estimated_completed_date }));
                    }}
                />
                <Select
                    label={t('input-weekend')}
                    value={project.weekend}
                    options={[true, false]}
                    renderOption={option => t(`weekend-${option ? 'included' : 'excluded'}`)}
                    onValue={weekend => {
                        const base = project.estimated_start_date;
                        const add = weekend ? addDays : addBusinessDays;
                        const estimated_start_date = !weekend && isWeekend(base) ? nextMonday(base) : base;
                        const estimated_completed_date = add(estimated_start_date, difference);
                        dispatch(actions.project.edit({ estimated_start_date, estimated_completed_date, weekend }));
                    }}
                />
            </div>
            {/* <DXCalendar
                containerWidth={800}
                currentDate={project?.estimated_start_date}
                projects={[
                    {
                        code: asset.code,
                        name: asset.name,
                        plan: plan?.id,
                        internal_due_date: plan?.internal_due_date,
                        external_due_date: plan?.external_due_date,
                        likelihood_risk: plan?.risk_assessment?.likelihood_risk,
                        consequence_risk: plan?.risk_assessment?.consequence_risk,
                        inspection: 0,
                        inspection_type: project.type,
                        type: project.type,
                        status: project.status,
                        in_progress_date: project.in_progress_date,
                        completed_date: project.completed_date,
                        estimated_start_date: project.estimated_start_date,
                        estimated_completed_date: project.estimated_completed_date,
                        rope_access: project.rope_access,
                        internal_scaffold: project.internal_scaffold,
                        heavy_cleaning: project.heavy_cleaning,
                    },
                ]}
            /> */}
        </div>
    );
};
